<!-- eslint-disable vue/require-v-for-key -->
<template>
  <sui-form>
    <table style="width: 100%">
      <tbody>
        <tr>
          <td style="width: 50%; vertical-align: top">
            <sui-form-field class="required" v-bind:class="fieldClass('licenseModel')">
              <label>License model</label>
              <sui-dropdown selection name="licenseModel" :options="licenseModels" v-model="license.licenseModel" />
              <span>{{ errors.first('valid-for-hours') }}</span>
            </sui-form-field>
            <sui-form-field class="required" v-bind:class="fieldClass('status')">
              <label>Status</label>
              <sui-dropdown selection name="status" :options="statuses" v-model="license.status" />
              <span>{{ errors.first('valid-for-hours') }}</span>
            </sui-form-field>
            <div v-if="
              license.licenseModel === 'perstudent' ||
              license.licenseModel === 'fixedprice'
            ">
              <sui-form-field class="required" v-bind:class="fieldClass('startDate')">
                <label>Start date</label>
                <input placeholder="start date" v-validate="'required'" name="startDate" type="date"
                  v-model="license.startDate" />
              </sui-form-field>
              <sui-form-field class="required" v-bind:class="fieldClass('durationMonths')">
                <label>Duration (months)</label>
                <input placeholder="12" v-validate="'required'" name="durationMonths" type="number" min="1"
                  v-model="license.durationMonths" />
              </sui-form-field>
            </div>
            <div v-if="license.licenseModel === 'other'">
              <sui-form-field v-bind:class="fieldClass('description')">
                <label>Invoice item description</label>
                <textarea name="description" v-model="license.description" />
              </sui-form-field>
            </div>
            <div v-if="
              license.licenseModel === 'fixedprice' ||
              license.licenseModel === 'other'
            ">
              <sui-form-field>
                <label>Fixed price</label>
                <vue-number name="fixedPrice" v-model="license.fixedPrice" v-bind="priceFormat" />
              </sui-form-field>
            </div>
            <div v-if="license.licenseModel === 'perstudent'">
              <sui-form-field class="required" v-bind:class="fieldClass('dueInDays')">
                <label>Student count</label>
                <input v-validate="'required'" name="dueInDays" type="number" min="1" v-model="license.studentCount" />
              </sui-form-field>
              <sui-form-field>
                <label>Price per student</label>
                <vue-number name="pricePerStudent" v-model="license.pricePerStudent" v-bind="priceFormat" />
              </sui-form-field>
            </div>
            <sui-form-field>
              <label>Discount</label>
              <vue-number name="discount" v-model="license.discount" v-bind="priceFormat" />
            </sui-form-field>

            <sui-form-field class="required" v-bind:class="fieldClass('vatRate')">
              <label>VAT rate</label>
              <vue-number name="vatRate" v-model="license.vatRate" v-validate="'required'" v-bind="vatRateFormat" />
            </sui-form-field>
            <sui-form-field class="required" v-bind:class="fieldClass('vatRate')">
              <label>VAT is only charged on an X percentage of license</label>
              <vue-number name="vatChargedOnPercentage" v-model="license.vatChargedOnPercentage" v-validate="'required'"
                v-bind="vatChargedOnPercentage" />
            </sui-form-field>
            <sui-form-field class="required" v-bind:class="fieldClass('dueInDays')">
              <label>Due in (days)</label>
              <input placeholder="30" v-validate="'required'" name="dueInDays" type="number" min="1"
                v-model="license.dueInDays" />
            </sui-form-field>
            <sui-form-field v-bind:class="fieldClass('poNumber')">
              <label>PO number</label>
              <input name="poNumber" v-model="license.poNumber" />
            </sui-form-field>
            <sui-form-field v-bind:class="fieldClass('number')">
              <label>Number</label>
              <input name="number" v-model="license.number" />
            </sui-form-field>
            <div v-if="error" class="ui negative message">
              <p>{{ error }}</p>
            </div>
            <sui-button type="button" positive icon="plus" v-on:click="submit">
              Save
            </sui-button>
          </td>
          <td style="width: 50%; vertical-align: top">
            <table style="width: 100%; margin: 10px">
              <tr>
                <td>School student count:</td>
                <td>
                  {{ school.totalStudentCount }}
                </td>
              </tr>
              <tr>
                <td>License cost ex. VAT:</td>
                <td>
                  {{ formatAsPrice(costExVat) }}
                </td>
              </tr>
              <tr>
                <td>VAT:</td>
                <td>
                  {{ formatAsPrice(vat) }}
                </td>
              </tr>
              <tr>
                <td>License cost inc. VAT:</td>
                <td>
                  {{ formatAsPrice(costIncVat) }}
                </td>
              </tr>
              <tr v-if="
                license.licenseModel === 'perstudent' ||
                license.licenseModel === 'fixedprice'
              ">
                <td>License valid until:</td>
                <td>
                  {{ endDate | moment('DD-MM-YYYY') }}
                </td>
              </tr>
              <tr>
                <td>Invoice due at:</td>
                <td>
                  {{ dueAt | moment('DD-MM-YYYY') }}
                </td>
              </tr>
            </table>
            <div style="width: 100%; margin: 10px">
              <div v-bind:key="index" v-for="(lineItem, index) in license.lineItems" style="
                  border-radius: 20px;
                  border: 1px solid #d4d4d5;
                  padding: 10px;
                  margin: 10px;
                ">
                <sui-form-field v-bind:class="fieldClass('description')">
                  <label>Description</label>
                  <textarea rows="3" name="description" v-model="lineItem.description" />
                </sui-form-field>
                <div style="
                    display: flex;
                    justify-content: space-between;
                    align-items: top;
                  ">
                  <sui-form-field v-bind:class="fieldClass('quantity')">
                    <label>Quantity</label>
                    <input v-validate="'required'" name="quantity" type="number" min="1" v-model="lineItem.quantity" />
                  </sui-form-field>
                  <sui-form-field v-bind:class="fieldClass('amount')">
                    <label>Price</label>
                    <vue-number name="price" v-model="lineItem.amount" v-bind="priceFormat" />
                  </sui-form-field>
                </div>
                <sui-button type="button" negative icon="minus" v-on:click="removeLineItem(lineItem.index)">
                  Remove line item
                </sui-button>
              </div>
              <sui-button type="button" positive icon="plus" v-on:click="addLineItem">
                Add line item
              </sui-button>
            </div>
          </td>
        </tr>
      </tbody>
    </table>
  </sui-form>
</template>

<script>
import moment from 'moment';
// eslint-disable-next-line import/no-extraneous-dependencies
import { component as VueNumber } from '@coders-tm/vue-number-format';

export default {
  name: 'LicenseForm',
  components: {
    VueNumber,
  },
  props: ['license', 'school', 'create', 'error'],
  data() {
    return {
      licenseModels: [
        { text: 'Fixed', value: 'fixedprice' },
        { text: 'Per student', value: 'perstudent' },
      ],
      statuses: [
        { text: 'Final', value: 'final' },
        { text: 'Draft', value: 'draft' },
        { text: 'Expiring', value: 'expiring' },
        { text: 'Expired', value: 'expired' },
      ],
      costExVat: 0.0,
      vat: '0.0',
      costIncVat: 0.0,
      endDate: null,
      dueAt: null,
      vatRateFormat: {
        decimal: '.',
        separator: ',',
        suffix: '%',
        precision: 0,
        masked: false,
        min: 0,
      },
      vatChargedOnPercentage: {
        decimal: '.',
        separator: ',',
        suffix: '%',
        precision: 0,
        masked: false,
        min: 0,
      },
      priceFormat: {
        decimal: '.',
        separator: ',',
        prefix: '€',
        precision: 2,
        masked: false,
        min: 0,
      },
    };
  },
  watch: {
    license: {
      immediate: true,
      deep: true,
      handler(val) {
        this.calculateCost(val);
      },
    },
  },
  methods: {
    reset() {
      this.$validator.reset();
    },
    formatAsPrice(value) {
      const formattedNumber = value.toFixed(2);
      const [integerPart, decimalPart] = formattedNumber.split('.');

      const formattedInteger = parseInt(integerPart, 10).toLocaleString(
        undefined,
        {
          minimumFractionDigits: 0,
          maximumFractionDigits: 0,
        },
      );

      return `€${formattedInteger}${decimalPart ? '.' : ''}${decimalPart || ''
        }`;
    },
    calculateCost(license) {
      this.costExVat = 0.0;
      if (license.licenseModel === 'perstudent') {
        this.costExVat = license.pricePerStudent * license.studentCount;
      } else {
        this.costExVat = license.fixedPrice;
      }
      this.costExVat = this.costExVat - license.discount;
      this.vat =
        this.costExVat *
        (license.vatChargedOnPercentage / 100) *
        (license.vatRate / 100);
      this.costExVat += license.lineItems.reduce(
        // eslint-disable-next-line no-mixed-operators
        (acc, item) => acc + item.amount * item.quantity,
        0,
      );
      this.costIncVat = this.costExVat + this.vat;
      // sum of all line items
      this.endDate = moment(license.startDate).add(license.durationMonths, 'M');
      const createdAt = license.createdAt
        ? moment(license.createdAt)
        : moment();
      this.dueAt = createdAt.add(license.dueInDays, 'd');
    },
    fieldClass(name) {
      const result = [];
      if (this.errors.first(name)) {
        result.push('error');
      }
      return result;
    },
    submit() {
      this.$validator.validate().then((result) => {
        if (result) {
          this.$emit('saved');
        }
      });
    },
    removeLineItem(index) {
      this.license.lineItems = this.license.lineItems.filter(
        // eslint-disable-next-line arrow-parens
        (item) => item.index !== index,
      );
    },
    addLineItem() {
      this.license.lineItems.push({
        index:
          this.license.lineItems.length > 0
            ? this.license.lineItems[this.license.lineItems.length - 1].index +
            1
            : this.license.lineItems.length,
        description: '',
        quantity: 1,
        amount: 0.0,
      });
    },
  },
  created() { },
};
</script>



// WEBPACK FOOTER //
// src/components/licenses/LicenseForm.vue